import React from "react";
import axios from "axios";
import { useUser } from '@/contexts/UserContext';
import { useTranslation } from 'react-i18next';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProgressivePromptCard = ({ question, onSave, onSkip }) => {
  const [value, setValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const { token } = useUser();
  const { t } = useTranslation();

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(question.key, value);
    } catch (error) {
      console.error("Error saving progressive answer:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleSkip = async () => {
    try {
      const cfg = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      await axios.post(`${API}/profile/progressive/skip`, { key: question.key }, cfg);
      onSkip();
    } catch (error) {
      console.error("Error skipping progressive question:", error);
    }
  };

  return (
    <div className="rounded-2xl p-4 mb-4" style={{ background: 'var(--c-surface-card)', border: '1px solid var(--c-border)' }}>
      <h3 className="text-sm font-medium mb-2" style={{ color: 'var(--c-texPri)' }}>{t(`progressive.${question.key}.title`, question.title)}</h3>
      {question.type === "text" && (
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={question.placeholder}
          className="w-full h-10 rounded-full px-3 text-sm focus:ring-0 mb-3 placeholder-[rgba(255,255,255,0.3)]"
          style={{ background: 'var(--c-surface-card)', border: '1px solid var(--c-border)', color: 'var(--c-texPri)' }}
        />
      )}
      {question.type === "select" && (
        <select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full h-10 rounded-full px-3 text-sm focus:ring-0 mb-3"
          style={{ background: 'var(--c-surface-card)', border: '1px solid var(--c-border)', color: 'var(--c-texPri)' }}
        >
          <option value="">{t('common.select', 'Select...')}</option>
          {question.options.map((opt) => (
            <option key={opt} value={opt}>{t(`progressive.${question.key}.options.${opt}`, opt)}</option>
          ))}
        </select>
      )}
      <div className="flex gap-2">
        <button
          onClick={handleSave}
          disabled={saving || !value}
          className="flex-1 h-10 text-sm font-medium rounded-full disabled:opacity-40 transition-all"
          style={{ background: 'linear-gradient(to right, #90d960, #6DB33F)', color: '#0a0a0a' }}
        >
          {saving ? "Saving..." : t('common.save', 'Save')}
        </button>
        <button
          onClick={handleSkip}
          className="flex-1 h-10 text-sm font-medium rounded-full transition-colors"
          style={{ background: 'var(--c-surface-card)', color: 'var(--c-texSec)', border: '1px solid var(--c-border)' }}
        >
          {t('common.skip', 'Skip')}
        </button>
      </div>
    </div>
  );
};

export default ProgressivePromptCard;